// extracted by mini-css-extract-plugin
export default {"PaymentWrapper":"styles_PaymentWrapper__3Qkpr","PaymentHead":"styles_PaymentHead__egLjJ","PaymentContainer":"styles_PaymentContainer__agoPR"};